/**
 * Global Size Chart Handler
 * Handles size chart button clicks using event delegation
 * Works even when content is dynamically loaded
 */

(function() {
  'use strict';

  function initSizeChart() {
    // Use event delegation on document level
    document.addEventListener('click', function(e) {
      // Handle size chart button click
      const button = e.target.closest('#size-chart-button');
      if (button) {
        e.preventDefault();
        e.stopPropagation();
        openSizeChartModal();
        return;
      }

      // Handle close modal click
      const closeBtn = e.target.closest('.close-modal');
      const modal = document.getElementById('size-chart-modal');
      
      if (closeBtn && modal) {
        closeSizeChartModal();
        return;
      }

      // Handle clicking outside modal
      if (e.target === modal) {
        closeSizeChartModal();
      }
    });

    // Handle escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const modal = document.getElementById('size-chart-modal');
        if (modal && modal.classList.contains('active')) {
          closeSizeChartModal();
        }
      }
    });
  }

  function openSizeChartModal() {
    const modal = document.getElementById('size-chart-modal');
    const imageContainer = document.getElementById('size-chart-image-container');
    const button = document.getElementById('size-chart-button');
    
    if (!modal || !imageContainer) {
      console.log('Size chart modal elements not found');
      return;
    }

    // Try to get image URL from data attribute first
    let imageUrl = button ? button.dataset.sizeChartUrl : null;
    
    // If not in data attribute, try to find it in the page's script tags
    if (!imageUrl) {
      const scripts = document.querySelectorAll('script');
      for (let script of scripts) {
        const content = script.textContent || script.innerHTML;
        
        // Match pattern: const sizeChartImage = `...`;
        const match = content.match(/const sizeChartImage\s*=\s*[`"']([^`"']+)[`"']/);
        if (match && match[1]) {
          imageUrl = match[1];
          break;
        }
        
        // Also try: sizeChartImage = "...";
        const match2 = content.match(/sizeChartImage\s*=\s*[`"']([^`"']+)[`"']/);
        if (match2 && match2[1]) {
          imageUrl = match2[1];
          break;
        }
      }
    }

    // Check if valid image URL
    if (!imageUrl || 
        imageUrl === '' || 
        imageUrl.includes('no-image') || 
        imageUrl.includes('liquid') ||
        imageUrl.includes('null') ||
        imageUrl.includes('undefined')) {
      console.log('No valid size chart image found');
      return;
    }

    // Display the modal
    imageContainer.innerHTML = `<img src="${imageUrl}" style="width:100%;height:auto;" alt="Size Chart">`;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeSizeChartModal() {
    const modal = document.getElementById('size-chart-modal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  // Export functions globally for potential external use
  window.openSizeChartModal = openSizeChartModal;
  window.closeSizeChartModal = closeSizeChartModal;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChart);
  } else {
    initSizeChart();
  }
})();
